import { render, staticRenderFns } from "./intervalPictures.vue?vue&type=template&id=72d49d1c&scoped=true&"
import script from "./intervalPictures.vue?vue&type=script&lang=ts&"
export * from "./intervalPictures.vue?vue&type=script&lang=ts&"
import style0 from "./intervalPictures.vue?vue&type=style&index=0&id=72d49d1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d49d1c",
  null
  
)

export default component.exports